import React from 'react';
import '../styles/Page.css';
import HeroSlider from '../components/HeroSlider';
import Decorations from '../components/Decorations';

const pillars = [
  {
    num: '01',
    title: 'Освіта',
    text:
      'Проводимо заняття, навчальні курси та майстер-класи, де діти отримують нові знання і практичні навички у доступній і живій формі.',
    icon: '/assets/icons/12_angle_star.png',
    accent: '#F9D423'
  },
  {
    num: '02',
    title: 'Розвиток',
    text:
      'Створюємо простір, де можна пробувати різні заняття, відкривати свої сильні сторони, вчитись взаємодіяти з іншими і впевненіше відчувати себе.',
    icon: '/assets/icons/mid_flower.png',
    accent: '#4ECDC4'
  },
  {
    num: '03',
    title: 'Підтримка',
    text:
      'Будуємо безпечне середовище, де дитина може отримати увагу, допомогу і супровід тоді, коли це потрібно, без зайвого тиску.',
    icon: '/assets/icons/heart.png',
    accent: '#E67E22'
  },
  {
    num: '04',
    title: 'Спільнота',
    text:
      'Об’єднуємо дітей, батьків, партнерів і бізнес навколо спільних ініціатив, подій і проєктів, які поступово змінюють середовище навколо дітей.',
    icon: '/assets/icons/yellow_bird.png',
    accent: '#A8D8EA'
  }
];

const projects = [
  {
    title: 'Superchef',
    image: '/assets/projects/project1.jpg',
    text:
      'Щомісяця у закладах мережі ресторанів Cukor запрошений зірковий шеф-кухар створює нову лімітовану страву. Усі кошти з її продажу спрямовуються на підтримку БО «ЛІТО».'
  },
  {
    title: 'Майстер-класи для дітей',
    image: '/assets/projects/project2.jpg',
    text: 'Щотижня проводимо майстер-класи з творчих напрямів для дітей.'
  },
  {
    title: 'Святкові події з «Місто добра»',
    image: '/assets/projects/project3.jpg',
    text:
      'Разом із «Місто Добра» ми організовуємо події, майстер-класи, екскурсії та здійснюємо мрії для дітей, які опинилися у складних життєвих обставинах.',
    link: 'https://misto-dobra.com.ua/'
  },
  {
    title: 'Мрії до дня Святого Миколая',
    image: '/assets/projects/project4.jpg',
    text:
      'Напередодні Святого Миколая діти надсилають листи у Cukor Group. А ми допомагаємо Миколаю здійснювати їхні мрії та доставляти подарунки.'
  }
];

export default function Home() {
  return (
    <main className="page landing" id="home">
      <Decorations />

      <div className="page-container home">
        {/* ГОЛОВНА */}
        <section className="hero">
          <div className="hero-text">
            <h1 className="hero-title">ЛІТО, де гостинність для дітей</h1>
            <p className="hero-subtitle">
              Ми створюємо можливості для дітей через освіту, натхненну цінностями
              гостинності, турботи та праці.
            </p>

            <div className="hero-actions">
              <a href="#join" className="btn btn-donate">
                Задонатити
              </a>
              <a href="#join" className="btn btn-subscribe">
                Оформити підписку
              </a>
            </div>
            <p className="support-note">Донат = навчання, менторство та нові можливості.</p>
          </div>
          <div className="hero-visual">
            <HeroSlider />
          </div>
        </section>

        {/* ПРО НАС */}
        <section className="manifest" id="about">
          <div className="section-header">
            <h2>Чим займається БО «ЛІТО»?</h2>
            <p>
              Cukor Group вже понад 10 років створює простори, куди хочеться
              повертатись: заклади, сервіси та досвід, у центрі яких людина і
              турбота. З часом ми зрозуміли, що гостинність не закінчується на
              дверях закладу.
            </p>
            <p className="manifest-extra">
              Так з’явилось ЛІТО. Це благодійна організація, яка працює з дітьми
              і створює для них можливості для навчання, розвитку і підтримки.
              Ми віримо, що турбота має бути системною і послідовною, а не
              випадковою, тому будуємо середовище, де діти можуть пробувати нове,
              відкривати себе і відчувати поруч дорослих, які їх підтримують.
            </p>
            <p className="manifest-extra">
              Ми працюємо через чотири напрями: освіта, розвиток, підтримка та
              спільнота.
            </p>
          </div>

          <div className="pillars-grid">
            {pillars.map((pillar) => (
              <article
                className="pillar-card"
                key={pillar.title}
                style={{ '--pillar-accent': pillar.accent }}
              >
                <span className="pillar-number" aria-hidden="true">
                  {pillar.num}
                </span>
                <img className="pillar-icon" src={pillar.icon} alt="" />
                <h3>{pillar.title}</h3>
                <p>{pillar.text}</p>
              </article>
            ))}
          </div>
        </section>

        {/* ПРОЄКТИ */}
        <section className="projects" id="projects">
          <div className="section-header">
            <h2>Проєкти</h2>
            <p>
              Ініціативи, через які ми системно створюємо можливості для дітей —
              разом із партнерами та спільнотою.
            </p>
          </div>

          <div className="project-grid">
            {projects.map((p) => (
              <article className="project-card" key={p.title}>
                <div className="project-image">
                  <img src={p.image} alt={p.title} loading="lazy" />
                </div>
                <div className="project-body">
                  <h3 className="project-title">
                    {p.link ? (
                      <a href={p.link} target="_blank" rel="noopener noreferrer">
                        {p.title}
                      </a>
                    ) : (
                      p.title
                    )}
                  </h3>
                  <p className="project-text">{p.text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* ДОЄДНАТИСЬ */}
        <section className="join" id="join">
          <div className="section-header">
            <h2>Доєднатись</h2>
            <p>
              Один донат або щомісячна підписка — це реальні заняття, події та
              підтримка для дітей. Обери формат, який комфортний саме тобі.
            </p>
          </div>

          <div className="join-grid">
            <article className="join-card">
              <h3>Разовий донат</h3>
              <p>Швидкий спосіб підтримати «ЛІТО» тут і зараз.</p>
              <a className="btn btn-donate" href="#contacts">
                Задонатити
              </a>
              <p className="join-hint">Можемо підʼєднати LiqPay/Mono — коли будете готові.</p>
            </article>

            <article className="join-card highlight">
              <h3>Щомісячна підписка</h3>
              <p>
                Стабільна підтримка, яка допомагає планувати програми довше ніж
                на один місяць.
              </p>
              <a className="btn btn-subscribe" href="#contacts">
                Оформити підписку
              </a>
              <p className="join-hint">Це найкращий спосіб підтримати системно.</p>
            </article>
          </div>
        </section>
      </div>
    </main>
  );
}
